import React, { useMemo } from "react";
import { NavLink, useLocation } from "react-router-dom";
import useMyAccount from "../../../../hooks/useMyAccount";

export const Menu = () => {
  const pathRoot = "/minha-conta";
  const location = useLocation();
  const { collaborators } = useMyAccount();

  const componentArray = useMemo(() => {
    const baseArray = [
      {
        label: "Minha Conta",
        path: "/perfil",
        icon: <i className="fas fa-user" />,
      },
      {
        label: "Meu Contato Terra",
        path: "/contato",
        icon: <i className="fas fa-briefcase" />,
      },
      {
        label: "Perfis de Colaboradores",
        path: "/colaboradores",
        icon: <i className="fas fa-users" />,
      },
      {
        label: "Histórico de Pedidos",
        path: "/historico-pedidos",
        icon: <i className="fa-solid fa-list" />,
      },
      {
        label: "Pagamento e Entrega",
        path: "/pagamento-entrega",
        icon: <i className="fa-solid fa-money-check-dollar" />,
      },
      {
        label: "Mude sua senha",
        path: "/alterar-senha",
        icon: <i className="fa-solid fa-lock" />,
      },
      {
        label: "Sair da conta",
        path: "/sair",
        icon: <i className="fas fa-sign-out-alt" />,
      },
    ];

    // Filtra o item "Perfis de Colaboradores" se não houver dados
    return baseArray.filter((item) => {
      if (item.path === "/colaboradores") {
        return collaborators && collaborators.length > 0;
      }
      return true;
    });
  }, [collaborators]);

  return (
    <>
      <div className="nav">
        {location.pathname.includes("detalhes") && location.pathname.includes("colaboradores") && (
          <NavLink to={`${pathRoot}/colaboradores`} style={{ background: "#000" }}>
            <i className="fas fa-arrow-left" />
            Voltar
          </NavLink>
        )}
        {location.pathname.includes("detalhes-empresa") && (
          <NavLink to={`${pathRoot}/perfil`} style={{ background: "#000" }}>
            <i className="fas fa-arrow-left" />
            Voltar
          </NavLink>
        )}
        {componentArray.map((item, index) => (
          <NavLink key={index} to={`${pathRoot}${item.path}`}>
            {item.label}
            {item.icon}
          </NavLink>
        ))}
      </div>
    </>
  );
};
